import { render, staticRenderFns } from "./ChatMessageImageDialog.vue?vue&type=template&id=369acba6&scoped=true&"
import script from "./ChatMessageImageDialog.vue?vue&type=script&lang=js&"
export * from "./ChatMessageImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageImageDialog.vue?vue&type=style&index=0&id=369acba6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369acba6",
  null
  
)

export default component.exports